import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IDebtsState } from './store/debts.state';
import { Observable } from 'rxjs';
import { getDebtsSelectorsState } from './store/debts.selectors';
import { Store } from '@ngrx/store';
import { setDebtsAction } from './store/debts.actions';
import {
  IDebts,
  IIndividualsDebts,
} from 'src/app/modules/interfaces/debts.interface';
import { DebtsService } from 'src/app/services/debts.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-debts',
  templateUrl: './debts.component.html',
  styleUrls: ['./debts.component.scss'],
})
export class DebtsComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();
  formsId: number;
  debtsData: IDebts = {
    id: 0,
    has_debts: null,
    wants_loans_study: null,
    individuals_loans: [],
  };

  typeOfCreditMap = {
    1: 'Financiamento Veicular',
    2: 'Financiamento Imobiliário',
    3: 'Cartão de Crédito',
    4: 'Crédito Consignado',
    5: 'Familiar/Amigo',
    6: 'Outros',
  };

  individualsLoansLocal: IIndividualsDebts[];

  isLoading = true;
  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  dataState$: Observable<IDebtsState>;
  dataState: IDebtsState = {
    check: false,
    debts: false,
    confirmDebts: false,
    listDebts: [],
  };

  listLocal: Array<any> = [];

  constructor(private store: Store, private debtsService: DebtsService) {
    this.formsId = Number(getCookie('formsId'));
  }

  async ngOnInit() {
    await this.getState();
    this.loadDebtsData();

    this.listLocal = [...this.dataState.listDebts];

    if (this.listLocal.length === 0) {
      await this.addList();
    }
  }

  loadDebtsData(): void {
    this.isLoading = true
    this.debtsService.getDebtsData(this.formsId).subscribe((response) => {
      if (response) {
        (this.debtsData = {
          id: response.id,
          has_debts: response.has_debts,
          wants_loans_study: response.wants_loans_study,
          individuals_loans: response.individuals_loans,
        }),
          (this.individualsLoansLocal = response.individuals_loans);
        this.saveState();
      }
    });
  }

  updateIndividualList(data, index): void {
    if (this.isValidIndex(index)) {
      const updatedDebts = [...this.debtsData.individuals_loans];
      updatedDebts[index] = { ...data };

      this.debtsData.individuals_loans = updatedDebts;
    }
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    const updateData: IDebts = {
      ...this.debtsData,
      wants_loans_study: this.debtsData.wants_loans_study ? 1 : 0,
    };
  
    this.debtsService
      .updateDebtsData(this.formsId, this.debtsData.id, updateData)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.saveButtonText = 'Salvo';
          this.saveButtonClass = 'btn-primary';
          this.saveState();
          this.formSaved.emit();
        },
        error: (err) => {
          this.isSaving = false;
          this.saveButtonText = 'Erro ao salvar';
          this.saveButtonClass = 'btn-danger';
          console.error('Erro ao atualizar os dados de Imovél', err);
        },
      });
  }

  saveState(): void {
    const formattedListDebts = this.individualsLoansLocal.map((debt) => ({
      check: true,
      typeDebt: this.typeOfCreditMap[debt.type_of_credit_id] || 'Outros',
      contractValue: debt.contract_value || 0,
      installmentValue: debt.installment_value || 0,
      interestRate: String(debt.interest_rate) || '',
      interestRateChoose: debt.interest_rate_period || '',
    }));
  
    this.dataState = {
      ...this.dataState,
      check: this.individualsLoansLocal.length > 0,
      debts: this.debtsData.has_debts === 1,
      confirmDebts: this.debtsData.wants_loans_study === 1,
      listDebts: formattedListDebts,
    };
  
    this.setState(this.dataState);
  }
  
  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary';
    }
  }

  isValidIndex(index: number): boolean {
    return index >= 0 && index < this.individualsLoansLocal.length;
  }

  addList(): void {
    if (!Array.isArray(this.individualsLoansLocal)) {
      this.individualsLoansLocal = [];
    }

    const newDebts: IIndividualsDebts = {
      loans_id: this.debtsData.id,
      type_of_credit_id: 1,
      contract_value: 0,
      installment_value: 1,
      interest_rate: 10,
      interest_rate_period: 'ano',
    };

    this.individualsLoansLocal = [
      ...this.debtsData.individuals_loans,
      newDebts,
    ];
    this.debtsData.individuals_loans = [
      ...this.debtsData.individuals_loans,
      newDebts,
    ];
  }

  getState(): void {
    this.dataState$ = this.store.select(getDebtsSelectorsState);

    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  setState(data: IDebtsState): void {
    this.store.dispatch(setDebtsAction(data));
    this.isLoading = false
  }

  setValuesForm(): void {
    this.dataState.check = !!this.dataState.debts;
    this.setState(this.dataState);
  }

  updateList(data, index): void {
    if (this.isValidIndex(index)) {
      const updatedVehicles = [...this.dataState.listDebts];
      updatedVehicles[index] = { ...data };

      this.dataState.listDebts = updatedVehicles;
      this.setState(this.dataState);
    }
  }

  deleteList(index: number): void {
    if (this.isValidIndex(index)) {
     
      this.individualsLoansLocal.splice(index, 1);
      this.debtsData.individuals_loans.splice(index, 1);

      this.dataState.listDebts = this.individualsLoansLocal.map((debt) => ({
        check: true,
        typeDebt: this.typeOfCreditMap[debt.type_of_credit_id] || 'Outros',
        contractValue: debt.contract_value || 0,
        installmentValue: debt.installment_value || 0,
        interestRate: String(debt.interest_rate) || '',
        interestRateChoose: debt.interest_rate_period || '',
      }));

      this.setState(this.dataState);
    }
  }
}
